/*global window*/
/*global setTimeout*/
angular.module('mtic.components.main', [
  'mtic.components.navbar',
  'mtic.components.login',
  'mtic.components.alert_popup',
  'mtic.components.timePicker',
  'mtic.components.translation',
  'mtic.components.mticAlertModal',

  'mtic.components.dashboards.student_general',
  'mtic.components.dashboards.teacher_general',

  'mtic.components.browser_popup',
  'mtic.components.dashboards.badbrowser',
  'mtic.components.select_box',
  'mtic.components.notifications'/*,
  'ngTouch'*/
]).config(function($sceDelegateProvider) {
  $sceDelegateProvider.resourceUrlWhitelist(['self', 'https://login.microsoftonline.com/**']);
});

angular.module('mtic.components.main')
.directive('mticApp', function (
  DEV_VARIABLES,
  LoginCookie,
  language,
  $log,
  $timeout,
  TIMING_CONSTANTS,
  $window,
  EventManager,
  userAccount,
  apiErrorInterpeter,
  $interval,
  api,
  apiMethods,
  preliveCheck,
  SessionDataService,
  MapStateService,
  $cookies,
  IAMManager,
  LocaleService,
  $q,
  $http,
  $sce,
  $rootScope,
  BRANDING,
  PlatformService,
  cordovaMessenger,
  URL_VERSIONS,
  Firebase,
  MticAlertModalService
) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope) {

      var eventManager = new EventManager('mticApp', scope);
      var showing_student_onboarding = false;
      scope.IAMLogoutTrigger = false;

      scope.getTranslation = function(slug){
        return language.get(slug);
      }

      function getBranding(){
        // TODO: implement logic for determining application branding
        // ...
        if (PlatformService.getQueryVariable('force-ocmt')) {
          $timeout(function(){
            window.olark('api.box.setLocale', 'en-US');
          }, 2500)
          return BRANDING.OCMT;
        }else{
          $timeout(function(){
            window.olark('api.box.setLocale', 'fr-FR')
          }, 2500)
        }

        return BRANDING.MTIC;
      }
      $rootScope.branding = getBranding();
      $rootScope.isMTIC = ($rootScope.branding === BRANDING.MTIC);
      $rootScope.isOCMT = ($rootScope.branding === BRANDING.OCMT);

      scope.alert = {}
      // prevent accidental closing
      EventManager.disableBeforeUnloadMsg = false;

      eventManager.listen('logging-in', function() {
        scope.logging_in = true;
      });

      eventManager.listen('done-login-attempt', function() {
        scope.logging_in = false;
      });

      if(LoginCookie.hasSessions()){
        $timeout(function(){
          eventManager.broadcast('login:session:restore')
        }, TIMING_CONSTANTS.SCOPE_REFRESH_DELAY_MS);
      }

      scope.isPreviewCheck = function(){
        return preliveCheck.isQCCheck()
      }

      if(Array.isArray($cookies.getObject('webembedcookie'))) {
        var webembedCookie = $cookies.getObject('webembedcookie');
        if(webembedCookie[0] === 'true'){
          window.isWebEmbedConnect = true;
        }
      }


      if(Array.isArray($cookies.getObject('updatedVersion'))) {
        var updatedVersionCookie = $cookies.getObject('updatedVersion');
        if(updatedVersionCookie[0] === 'true'){
          window.updatedVersion = true;
        }
      }

      if(Array.isArray($cookies.getObject('latestVersionCheck'))) {
        var latestVersionCheck = $cookies.getObject('latestVersionCheck');
        if(latestVersionCheck[0] === 'true'){
          window.latestVersion = true;
        }
      }

      var token_saved_url = IAMManager.getSavedUrlParamsForToken();

      /**
      * Set user values for navbar
      */
      var setUser = function () {
        scope.user = {
          fullName: userAccount.getData().fullName,
          logout: userAccount.logout
        };
        scope.isTeacher = userAccount.getData().role.isTeacher;

        $window.addEventListener('beforeunload', function (event) {
          if (!PlatformService.supportsBeforeUnloadMsg || EventManager.disableBeforeUnloadMsg) {
            return;
          }
          eventManager.broadcast('browser:tab:beforeunload:shown')
          eventManager.beforeunloadWarning();
          $timeout(function() {
              eventManager.broadcast('browser:tab:beforeunload:cancelled')
          }, TIMING_CONSTANTS.BEFORE_UNLOAD_DELAY_MS);
          event.returnValue = 'Are you sure you want to leave?';
          return event.returnValue;
        });
      }

      /**
      * Make Listeners
      */
      eventManager.listen('app:open', function (e, pageToOpen) {
        if(!DEV_VARIABLES.BROWSER_SUPPORT.IS_SUPPORTED() && !(PlatformService.isAndroid || PlatformService.isIos && !window.MSStream)) {
          scope.badBrowser = true;
        }
        scope.pageShown = null;
        $timeout(function(){
          scope.pageShown = pageToOpen;
        }, 100)
      })
      eventManager.listen('login:first', function () {
        setUser()
        if (userAccount.getData().role.isGeneralAccess) {
          eventManager.broadcast('app:open', 'mtic-finalization');
        } else if (userAccount.getData().role.role_type === 'mtic_student') {
          eventManager.broadcast('app:open', 'student');
        } else {
          eventManager.broadcast('app:open', 'teacher');
        }
        eventManager.broadcast('done-login-attempt');
        
        if(PlatformService.isApp && PlatformService.isIos){
          var current_app_version = PlatformService.getQueryVariable('app-version')
          if(current_app_version){
            var app_version = parseInt(current_app_version.split('.').join(''))
            var latest_version = 609
            if(app_version < latest_version){
              $timeout(function(){
                window.confirm('There is a new version available for this app, please visit the Appstore to upgrade.')
              }, 2500)
            }
          }
        }
      })
      eventManager.listen('login:session-refresh', function (keepMoving) {
        setUser()
        eventManager.broadcast('session-expiry:close')
      })
      eventManager.listen('login:cookies', function (e, eventData) {
        eventManager.broadcast('login:first');
      })
      eventManager.listen('logout', function (e, atLeastOneLoggedOut) {
        $timeout ( function(){
          scope.IAMLogoutTrigger = true;
          var link = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.href;
          if(PlatformService.isMobile && !window.MSStream && LocaleService.getIfIamUser() && !userAccount.isSamlUser()) {// TODO why is this logic different from that in the 'app:open' listener, above?
            //scope.custom = 'ANDROID LOGOUT: '+ link;
            window.open(link, '_self');
          } else if (userAccount.isSamlUser && PlatformService.isApp) {
            cordovaMessenger.postToCordova('refreshAppFrame');
            //
          } else if (userAccount.isSamlUser && !PlatformService.isApp) {
            window.location.hash = '';
            window.location.reload();
          } else if(!LocaleService.getIfIamUser()){
            var url = $window.location.href.split('?')[0];
            var queryFlags = [];
            if($rootScope.isOCMT){
              queryFlags.push('force-ocmt')
            }
            if(PlatformService.getQueryVariable('no-watermark')){
              queryFlags.push('no-watermark')
            }
            if(queryFlags.length){
              url += ('?' + queryFlags[0])
            }
            if(queryFlags.length > 1){
              for(var i=1; i<queryFlags.length; i++){
                url += ('&' + queryFlags[i])
              }
            }
            $window.location.href = url.split('/#')[0];
          }else{
            $window.location.href = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.href;
          }
        }, 500);

        // if(!atLeastOneLoggedOut) {
        //   $window.location.reload();
        // }
        //$window.location.href = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=http%3A%2F%2Flocalhost%3A3000%2F';
      })
      eventManager.listen('login:session:clear', function () {
        delete scope.user;
        eventManager.broadcast('app:open', 'login');
      })
      eventManager.listen('login:fail', function (e, message) {
        scope.alert.text = apiErrorInterpeter.get('LOGIN', message)
        scope.alert.type = 'danger'
      })
      eventManager.listen('signup:fail', function (e, message) {
        scope.alert.text = apiErrorInterpeter.get('SIGNUP', message)
        scope.alert.type = 'danger'
      })
      eventManager.listen('module:open:resource', function (e, resource) {
        if(resource.slug) {
          eventManager.setResourceSession(resource.slug, resource.id)
        }else{
          throw "Please put the resource and resource.slug back in the event emission of `module:open:resource`"
        }
      })
      eventManager.listen('set:user:language', function(e, slug){
        $log.log('language change : ', slug)
        if(userAccount.isLoggedIn()){
          api.setUserLanguage(slug);
        }
      })
      eventManager.listen('module:close:resource', function (e, args) {
        language.resetAvilableOptions();
        $timeout(function(){
          eventManager.clearResourceSession();
          scope.userTimeout.cancelResourceListeners();
        }, 100)
      })

      eventManager.listen("navbar:my-classes:click", function() {
        MapStateService.setActiveModule("");
      })

      /**
       * Defaults
       */
      scope.pageShown = null;
      scope.badBrowser = false;
      scope.languageService = language;


      eventManager.broadcast('app:open','login');
      eventManager.listen('offline-post-call', function(){
        scope.offline_post_submission = true;
        scope.logging_out = false;
      })

      scope.resubmit_offline_post = function(){
        scope.offline_post_submission = false;
        apiMethods.resubmitOfflinePost()
      }

      var logged_out = false
      eventManager.listen('logging-out', function(e){
        scope.logging_out = true;
        logged_out = true;
      })

      eventManager.listen('offline-post-call-resolved', function(){
        if(logged_out){
          location.reload();
        }
      });

      scope.getCurLink = function(){
        return window.location.host;
      }
      scope.isNotLive = function(){
        return LocaleService.getUrlVersion() !== URL_VERSIONS.Live;
      }
      scope.displayPrevLiveTab = scope.isNotLive() && !PlatformService.getQueryVariable('no-watermark');
      scope.custom = ''
      eventManager.listen('change-prelive-message', function(e, args){
        // scope.preliveMessage = 'change link :  ' + args;
        scope.gotCustom = true;
        scope.custom = args;
      })

      scope.getWindowLocation = function(){
        return 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.href;
      }

      scope.hide_admin_view = function(){
        scope.admin_view_shown = false;
      }

      eventManager.listen('show_admin_view', function(e){
        scope.admin_view_shown = true;
      })


    // redirecting to browser view
     var url = window.location.href;

    var auto_login = false;
    function setAutoLoginData(params){
      var userRole = userAccount.setData(params.info.email, params);
      apiMethods.setGroupId(userRole.group_id);
      Firebase.auth().signInWithCustomToken(params.firebaseToken);
      eventManager.broadcast('login:first');
      LocaleService.setAsIamUser();
      if(document.location.hash.indexOf('open_item_link') > -1){
        document.location.hash = 'open_item_link'+document.location.hash.split('open_item_link')[1];
      }else{
        document.location.hash = '';
      }
    }

    if(url.indexOf('auto_login') > -1){
      auto_login = true;
      eventManager.broadcast('logging-in');
      var auto_login_params = JSON.parse(decodeURIComponent(url.split('auto_login=')[1].split('&open_item_link')[0]));
      // $log.log('AUTO LOGIN :  ', _.clone(auto_login_params));
      apiMethods.setHeaders(auto_login_params.session_key, auto_login_params.user_id, auto_login_params.access_token, auto_login_params.refresh_token);
      if(auto_login_params.roles){
        setAutoLoginData(auto_login_params);
      }else{     
        api.getUserGroups().then(function(roles){
          var lowercase_roles = [];
          _.each(roles, function(role){
            var lowercase_role = _.transform(role, function (result, val, key) {
              result[key.toLowerCase()] = val;
            });
            lowercase_roles.push(lowercase_role);
          })
          // $log.log('GOT USER ROLES : ' , lowercase_roles);
          auto_login_params.roles = lowercase_roles;          
          setAutoLoginData(auto_login_params);
        })
      }
    }else if(url.indexOf('login_error') > -1){
      $log.log('LOGIN ERROR !');
      var login_errorParams = JSON.parse(decodeURIComponent(url.split('login_error=')[1]));
      if (login_errorParams.isSamlUser) {
        userAccount.setIsSamlUser(true);
      }
      MticAlertModalService.set('USER LOGIN FAILED', {
        title: 'IAM Login',
        callback: function(){
          userAccount.logout()
        }
      })
      if(document.location.hash.indexOf('open_item_link') > -1){
        document.location.hash = 'open_item_link'+document.location.hash.split('open_item_link')[1];
      }else{
        document.location.hash = '';
      }
    }

    if(url.indexOf('web-open-browser&') > -1){
      window.isWebEmbedConnect = false;
      var url_params = url.split('web-open-browser&')[1];
      var url_parse = url_params.split('&');
      var params = {};
      url_parse.forEach( function(param){
        var cur = param.split('=');
        params[cur[0]] = cur[1];
      })
      apiMethods.loginRestore(params.uuid, params.user_id, params.session_key, params.firebase_token).then(function(){

      });
    }

    function autologin(){      
      var loginCookies = $cookies.getObject('logincookies');
      if(loginCookies.length > 0){
          var latest = loginCookies[0];
          $timeout(function(){
            eventManager.broadcast('start-login-attempt');
            if(latest.userid && latest.sessionkey && latest.username && latest.firebaseToken){
                apiMethods.loginRestore(latest.username, latest.userid, latest.sessionkey, latest.firebaseToken, true)
                .then(function(){
                  eventManager.broadcast('done-login-attempt');
                })
                .catch(function(){
                  eventManager.broadcast('done-login-attempt');
                })
            }
          }, 500)

      }
    }
    // (window.isWebEmbedConnect || location.href.indexOf('localhost') > -1 || location.href.indexOf('192') > -1)
    if(location.href.indexOf('open_item_link') > -1 && Array.isArray($cookies.getObject('logincookies')) && !auto_login) {
      autologin();
    }
    eventManager.listen('app:auto:login', autologin)

     scope.loginAs = function(user_id, uuid){
      apiMethods.loginAs({user_id: user_id, uuid: uuid})
      .then((res)=>{
        scope.admin_view_shown = false;
      })
     }

     scope.hideAdminPopup = function(){
        scope.admin_view_shown = false;
     }


     eventManager.listen('refresh-token-expired', function(){
        scope.refreshTokenIsExpired = true;
     });

     scope.token_expiry_logout = function(){
      userAccount.logout();
     }

     eventManager.listen('token-expired-logout', () => {
      userAccount.logout();
     });

      scope.userTimeout = {

        idle_start_60s: false,
        away_start_check: false,
        idle_start_300s: false,
        fifteen_s_ping: null,
        sixty_s_ping: null,
        // iframe_focus_check:null,
        // resource_loader_focus_check: null,

        startTimers: function () {
          scope.userTimeout.ping = window.setTimeout(scope.userTimeout.goInactive, 60000);
          scope.userTimeout.inactivityWarning = window.setTimeout(scope.userTimeout.showInactivityWarning, 1740000);
          scope.userTimeout.halfHourPing = window.setTimeout(scope.userTimeout.logUserOut, 1800000);
          if (!scope.userTimeout.idle_start_60s) {
            scope.userTimeout.idle_start = window.setTimeout(scope.userTimeout.startIdle, 60000);
          }
          if(!scope.userTimeout.away_start_check){
            scope.userTimeout.away_start = window.setTimeout(scope.userTimeout.goInactiveAway, 600000);
          }
        },

        startIdle: function() {
          // eventManager.broadcast('user:idleStart60s')
          scope.userTimeout.idle_start_60s = true;
          eventManager.broadcast('idle:inputs:start')
          LocaleService.idleInput = true;
          window.clearTimeout(scope.userTimeout.idle_start);
          // if (!scope.userTimeout.idle_start_60s) {
          //   scope.userTimeout.idle_start_long = window.setTimeout(scope.userTimeout.startIdle300, 300000);
          //   // $log.log('idle60')
          // }

        },

        startIdle300: function() {
          // eventManager.broadcast('user:idleStart300s')
          // $log.log('idle300')
        },

        resetTimers: function (e) {
          // $log.log('reseting timer')
          window.clearTimeout(scope.userTimeout.ping);
          window.clearTimeout(scope.userTimeout.inactivityWarning);
          window.clearTimeout(scope.userTimeout.halfHourPing);
          window.clearTimeout(scope.userTimeout.idle_start);
          window.clearTimeout(scope.userTimeout.idle_start_long);
          window.clearTimeout(scope.userTimeout.away_start);
          scope.inactivityWarningShown = false;

          LocaleService.idleInput = false;
          LocaleService.isAway = false;
          if (scope.userTimeout.idle_start_60s) {
            // $log.log('inidle')
            // eventManager.broadcast('user:idle_end')
            eventManager.broadcast('idle:inputs:end')
            eventManager.broadcast('mouse:keyboard:active', {idleInput: LocaleService.idleInput, away: LocaleService.isAway});
          }

          scope.userTimeout.idle_start_60s = false;
          scope.userTimeout.away_start_check = false;
          scope.userTimeout.startTimers();
        },

        goInactive: function () {
          eventManager.broadcast('user:inactiveForOneMinutePing')
        },
        logUserOut: function () {
          if(userAccount.isLoggedIn()){
            eventManager.broadcast('user:InactiveForThirtyMinutes');
            window.clearTimeout(scope.userTimeout.logUserOut);
            userAccount.logout();
          }
        },
        showInactivityWarning: function(){
          if(userAccount.isLoggedIn()){
            scope.inactivityWarningShown = true;
            window.clearTimeout(scope.userTimeout.inactivityWarning);
          }
        },
        goInactiveAway: function(){
          scope.userTimeout.away_start_check = true;
          LocaleService.isAway = true;
        },

        cancelResourceListeners: function(){
          $interval.cancel(scope.userTimeout.fifteen_s_ping)
          // $interval.cancel(scope.userTimeout.resource_loader_focus_check)
          scope.userTimeout.fifteen_s_ping = null;
          // scope.userTimeout.resource_loader_focus_check = null;

          // $interval.cancel(scope.userTimeout.iframe_focus_scheck)
          // scope.userTimeout.iframe_focus_check = null;
        },

        setup: function () {
          var hidden = "hidden";
          // Standards:
          if(window.isWebEmbedConnect && PlatformService.isIos){
            document.addEventListener("pagehide", onchange);
            document.addEventListener("pageshow", onchange);
          }else if (hidden in document){
            document.addEventListener("visibilitychange", onchange);
          }else if ((hidden = "mozHidden") in document){
            document.addEventListener("mozvisibilitychange", onchange);
          }else if ((hidden = "webkitHidden") in document){
            document.addEventListener("webkitvisibilitychange", onchange);
          }else if ((hidden = "msHidden") in document){
            document.addEventListener("msvisibilitychange", onchange);
          }// IE 9 and lower:
          else if ("onfocusin" in document){
            document.onfocusin = document.onfocusout = onchange;
          // All others:
          }else{
            window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;
          }
          function onchange (evt) {
            if(LocaleService.idleFocus){
              eventManager.broadcast('focusout:end')
              LocaleService.idleFocus = false;
              eventManager.broadcast('mouse:keyboard:active', {idleInput: LocaleService.idleInput, away: LocaleService.isAway, returned_from_away: true});
            }else{
              eventManager.broadcast('focusout:start')
              LocaleService.idleFocus = true;
            }
          }

          document.addEventListener("mousemove", scope.userTimeout.resetTimers, false);
          document.addEventListener("mousedown", scope.userTimeout.resetTimers, false);
          document.addEventListener("pointerdown", scope.userTimeout.resetTimers, false);
          document.addEventListener("pointermove", scope.userTimeout.resetTimers, false);
          document.addEventListener("pointerup", scope.userTimeout.resetTimers, false);
          document.addEventListener("touchstart", scope.userTimeout.resetTimers, false);
          document.addEventListener("touchend", scope.userTimeout.resetTimers, false);
          document.addEventListener("keypress", scope.userTimeout.resetTimers, false);
          document.addEventListener("DOMMouseScroll", scope.userTimeout.resetTimers, false);
          document.addEventListener("mousewheel", scope.userTimeout.resetTimers, false);
          document.addEventListener("touchmove", scope.userTimeout.resetTimers, false);
          document.addEventListener("MSPointerMove", scope.userTimeout.resetTimers, false);


          eventManager.listen('iframe-idle-reset', function(){
            scope.userTimeout.resetTimers();
          });

          eventManager.listen('resource:load:complete', function(){
            if(!scope.userTimeout.fifteen_s_ping){
              scope.userTimeout.fifteen_s_ping = $interval(function(){
                eventManager.broadcast('mouse:keyboard:active:first', {idleInput: LocaleService.idleInput});
                $interval.cancel(scope.userTimeout.fifteen_s_ping);
                scope.userTimeout.fifteen_s_ping = null;
              }, 15000)
            }
          })

          eventManager.listen('teacher:change:tab', function(){
            scope.userTimeout.cancelResourceListeners();
          })

          scope.userTimeout.sixty_s_ping = $interval(function(){
            eventManager.broadcast('mouse:keyboard:active', {idleInput: LocaleService.idleInput, away: LocaleService.isAway});
          }, 60000)

          scope.userTimeout.startTimers();
        },
      }

      // listeners for native events moved to the cordovaMessenger service
      if(PlatformService.isApp){
        cordovaMessenger.postToCordova('siteIsReady', {});
      }

      scope.userTimeout.setup()

      if(PlatformService.isIos && PlatformService.isApp){
        document.addEventListener('touchend', function(){
          window.focus()
        })
      }

      
    window.addEventListener(
        'message',
        function (event) {
          if (event.data.startsWith && !event.data.startsWith('!')) {
            var eventData = JSON.parse(event.data);
            if ('open_pdf_request' === eventData.type && eventData.payload  && eventData.payload.pdf_url) {
              if (PlatformService.isApp){
                cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: eventData.payload.pdf_url });
              } else {
                window.open(eventData.payload.pdf_url ,'_blank');
              }
            }
          }
        },
        false
      );
      
    }
  }
})
